module.exports = __webpack_public_path__ + "newprotal/img/adv-01.857d2645.jpg";